import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from "react-router-dom";
import Drawer from "react-bottom-drawer";
import "../../../stylesheets/components/dowloadHoldingReports/dowloadHoldingReportsMob.scss";
import { ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { useDispatch, useSelector } from "react-redux";
import { enterMail, validMail } from "@domains/utils/commonText";
import { pnlDownloadDate, } from "@domains/utils/reportDates";
import { previousDay } from "@domains/utils/reportDates";
import { storeEmailListInSessionStorage } from "@domains/utils/sessionMethods";
import { HOLDING_HIDE_ERROR } from "@frameworks/web/redux/interfaces/Reports/iHoldingReport";
import { HoldingErrorEnum } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import { isLoginSourceEMT } from "@domains/utils/emtReportCallback";
import { emailRegex } from "@frameworks/web/utils/regex";
import config from "@frameworks/web/config/domain";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { useParams } from "react-router-dom";
import { avoidPANProtectionMessage } from "@frameworks/web/components/generic/DownloadReports/DownloadReportPopupDesk";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
const CommonDownloadReport = (props) => {
    var _a;
    const navigate = useNavigate();
    const device = DeviceContext();
    const { loginSource } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const activeSubTabOtherReport = getQueryParameterName("tab");
    const [fromDate, setFromDate] = useState(props.startDate);
    const [toDate, setToDate] = useState(props.endDate);
    const [isVisible, setIsVisible] = React.useState(false);
    const [emailList, setEmailList] = useState([]);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const sessionEmailList = sessionStorage.getItem("emailList");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [PDF_or_Excel, setPDForExcel] = useState((props === null || props === void 0 ? void 0 : props.PDF_or_Excel) ? props === null || props === void 0 ? void 0 : props.PDF_or_Excel : null);
    const [currEmailvalue, setCurrEmailValue] = useState();
    const [isIconDisabled, setIsIconDisabled] = useState(true);
    const [openCalendarBetween, setOpenCalendarBetween] = React.useState(false);
    const [selectedDateRange, setSelectedDateRange] = useState("startDateSelected");
    const _calendar = useRef(null);
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const emailStatus = useSelector((state) => state.holdingReport.emailStatus);
    const downloadStatus = useSelector((state) => state.holdingReport.downloadStatus);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const defaultEmailId = useSelector((state) => state.accountDetailsReducer.emaildId);
    const isClientLogin = loginSource !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const showDatePicker = (e) => {
        setIsVisible(true);
        if (_calendar.current) {
            _calendar.current.setOpen(true);
        }
    };
    const dateChange = (dates) => {
        const [start, end] = dates;
        setFromDate(start);
        setToDate(end);
        setSelectedDateRange(end ? "startDateSelected" : "endDateSelected");
        if (end) {
            setOpenCalendarBetween(false);
        }
    };
    const closeDrawerDate = () => {
        setIsVisible(false);
    };
    React.useEffect(() => {
        setFromDate(props.startDate);
        if (props.withEndDate)
            setToDate(props.endDate);
    }, [props.startDate, props.endDate]);
    const EmailListUpdate = () => {
        if (emailRegex.test(currEmailvalue) &&
            !emailList.includes(currEmailvalue)) {
            setEmailList([...emailList, currEmailvalue]);
            storeEmailListInSessionStorage(currEmailvalue, sessionEmailList, true);
            setCurrEmailValue("");
            return [...emailList, currEmailvalue];
        }
        return [];
    };
    const openDrawerLoader = React.useCallback(() => props.setShowLoader(true), []);
    const openDrawerDownloadS = React.useCallback(() => props.setDownloadSuccess(true), []);
    const openDrawerFail = React.useCallback(() => props.setDownloadFail(true), []);
    const closeDrawerLoader = React.useCallback(() => props.setShowLoader(false), []);
    const goBack = () => {
        dispatch({
            type: HOLDING_HIDE_ERROR,
            errorType: HoldingErrorEnum.DOWNLOADSTATUS,
        });
        const destination = ".." + config.feReportBase + "?reportName=Holding";
        navigate(destination, { replace: true });
    };
    const isAdditionalMsg = (props === null || props === void 0 ? void 0 : props.isAdditionalMsg)
        ? props === null || props === void 0 ? void 0 : props.isAdditionalMsg(fromDate, toDate)
        : null;
    let handleSubmit = (e) => {
        e.preventDefault();
        if (!isLoginSourceEMT(lgnSrc))
            openDrawerLoader();
        let emailFormat = undefined, downloadFormat = undefined;
        if (downloadCheck) {
            downloadFormat = {
                fromDate: moment(fromDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
            };
            if (props.withEndDate)
                downloadFormat.toDate = moment(toDate).format("yyyy-MM-DD");
            props.setOperation("download");
        }
        if (emailCheck) {
            let list = emailList;
            if (emailList.length === 0 && currEmailvalue.length > 3) {
                list = EmailListUpdate();
            }
            emailFormat = {
                fromDate: moment(fromDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
                emailIds: list,
            };
            if (props.withEndDate)
                emailFormat.toDate = moment(toDate).format("yyyy-MM-DD");
            props.setOperation("email");
        }
        if (downloadCheck && emailCheck) {
            props.setOperation("email_download");
        }
        props.submitDownload(emailFormat, downloadFormat, downloadCheck, emailCheck);
        if (isLoginSourceEMT(lgnSrc)) {
            goBack();
        }
    };
    useEffect(() => {
        if ((emailStatus.isOpen !== null || downloadStatus.isOpen !== null) &&
            props.showLoader &&
            (emailCheck || downloadCheck)) {
            closeDrawerLoader();
            if ((emailCheck && emailStatus.isOpen === true) ||
                (downloadCheck && downloadStatus.isOpen === true)) {
                openDrawerDownloadS();
            }
            else {
                openDrawerFail();
            }
        }
    }, [emailStatus.isOpen, downloadStatus.isOpen]);
    useEffect(() => {
        const trimmedValue = (currEmailvalue === null || currEmailvalue === void 0 ? void 0 : currEmailvalue.trim()) || "";
        const isValueEmpty = trimmedValue === "";
        const isValidEmail = emailRegex.test(trimmedValue);
        setCurrEmailValue(trimmedValue);
        setIsIconDisabled(isValueEmpty || !isValidEmail);
    }, [currEmailvalue, emailRegex]);
    useEffect(() => {
        if (defaultEmailId && !emailList.includes(defaultEmailId)) {
            let defaultEmailList = [defaultEmailId];
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = defaultEmailList;
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
        else {
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = emailList && emailList.length > 0 ? emailList : [];
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    if (!emailList.includes(emailId))
                        finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
    }, [defaultEmailId, emailCheck]);
    useEffect(() => {
        if (PDF_or_Excel && (emailCheck || downloadCheck)) {
            if (emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && !emailCheck) {
                setSubmitDisabled(true);
            }
            else {
                setSubmitDisabled(false);
            }
        }
        else
            setSubmitDisabled(false);
        if (props.setEmailCheck)
            props.setEmailCheck(emailCheck);
        if (props.setDownloadCheck)
            props.setDownloadCheck(downloadCheck);
    }, [emailCheck, emailList, downloadCheck, PDF_or_Excel]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `customForm mobForm common-download-newtheme ${(_a = props === null || props === void 0 ? void 0 : props.parentClass) !== null && _a !== void 0 ? _a : ""}` }, device && device.isDesktop ? (React.createElement(React.Fragment, null,
            " ",
            React.createElement("form", { className: "customFormSection", onSubmit: (e) => handleSubmit(e), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        if (!currEmailvalue && submitDisabled) {
                            handleSubmit(e);
                        }
                    }
                } },
                React.createElement(Link, { to: config.feReportBase },
                    React.createElement("div", { className: "d-flex align-items-center mobFormHead" },
                        React.createElement("i", { className: "edel-icon-arrow-left1" }),
                        React.createElement("h1", null, "Download Holdings Reports"))),
                React.createElement("div", null,
                    React.createElement("div", { className: "mobFormWrap" },
                        React.createElement("div", { className: "customFormSection_field dateWrap" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-12 col-lg-12" },
                                    React.createElement("label", { htmlFor: "date", className: "date-label" }, "Date"),
                                    React.createElement("div", { className: "" },
                                        React.createElement("div", { className: "input-group datePickerModal" },
                                            React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(fromDate).format("DD-MMM-YY") }),
                                            React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerDate, isVisible: isVisible, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                                                React.createElement("div", null,
                                                    React.createElement("div", { className: "drawer-container" },
                                                        React.createElement("div", { className: "date-container" },
                                                            React.createElement("label", { className: "select-date" }, "Select Date"),
                                                            React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(fromDate).format("DD-MMM-YY"), readOnly: true })),
                                                        React.createElement(DatePicker, { placeholderText: "dd-mm-yy", dateFormat: "d-MMM-yy", onChange: (date) => setFromDate(date), ref: _calendar, inline: true, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), selected: fromDate, minDate: props.minDate
                                                                ? props.minDate
                                                                : pnlDownloadDate, maxDate: previousDay, scrollableYearDropdown: true, useShortMonthInDropdown: true, yearDropdownItemNumber: props.minDate
                                                                ? previousDay.getFullYear() -
                                                                    props.minDate.getFullYear() +
                                                                    1
                                                                : previousDay.getFullYear() -
                                                                    pnlDownloadDate.getFullYear() +
                                                                    1 }),
                                                        React.createElement("a", { className: "btn btn-primary custom_btn", onClick: () => setIsVisible(false) }, "Apply")))),
                                            React.createElement("a", { className: "input-group-append", onClick: showDatePicker },
                                                React.createElement("span", { className: "change-text" },
                                                    React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                    React.createElement("span", null, "Change")))))))),
                        React.createElement("div", { className: "customFormSection_field radioField" },
                            React.createElement("label", { htmlFor: "", className: "date-label" }, "Report Format"),
                            React.createElement("div", { className: "radio" },
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: (e) => setPDForExcel(ReportType.PDF), required: true, checked: PDF_or_Excel !== null &&
                                            PDF_or_Excel === ReportType.PDF
                                            ? true
                                            : false }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault1" }, "PDF")),
                                props.hideExcel ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: (e) => {
                                            setPDForExcel(ReportType.EXCEL);
                                            isImpersonated && setDownloadCheck(false);
                                        }, 
                                        // disabled={isImpersonated && lgnSrc !== "nesttrader"}
                                        required: true, checked: PDF_or_Excel !== null &&
                                            PDF_or_Excel === ReportType.EXCEL
                                            ? true
                                            : false }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault2" }, "Excel"))))),
                        React.createElement("div", { className: "mailCheckbox" },
                            React.createElement("div", { className: "customFormSection_field checkboxWrap" },
                                React.createElement("label", { htmlFor: "", className: "date-label " }, "Get Report As"),
                                React.createElement("div", { className: "checkbox" },
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", name: "downloadType[]", id: "flexCheckDefault", disabled: isImpersonated &&
                                                lgnSrc !== "nesttrader" &&
                                                PDF_or_Excel &&
                                                PDF_or_Excel === ReportType.EXCEL, checked: isImpersonated &&
                                                PDF_or_Excel === ReportType.EXCEL
                                                ? false
                                                : downloadCheck, onChange: (e) => {
                                                setDownloadCheck(e.target.checked);
                                            }, required: !(downloadCheck || emailCheck) }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckDefault" }, "Download")),
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckChecked", name: "downloadType[]", onChange: (e) => {
                                                // setshowMailInput(e.target.checked);
                                                setEmailCheck(e.target.checked);
                                            }, required: !(downloadCheck || emailCheck) }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckChecked" }, "Email")))),
                            emailCheck && (React.createElement("div", { className: "customFormSection_field mailWrap" },
                                React.createElement("div", { className: "blue_bg  bg_white mail" },
                                    emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                        React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                            return (React.createElement("li", { key: idx, className: "mail_label_body_item" },
                                                React.createElement("div", { className: "text-truncate" }, el),
                                                React.createElement("span", { className: "mail_label_close", onClick: () => {
                                                        setEmailList((emailList) => emailList.filter((_, i) => emailList[i] !== el));
                                                        storeEmailListInSessionStorage(el, sessionEmailList, false);
                                                    } },
                                                    React.createElement("i", { className: "edel-icon-rounded-close" }))));
                                        })))),
                                    React.createElement("div", { className: "mail-input" },
                                        React.createElement("input", { ref: inputRef, type: "email", className: "form-control", disabled: isImpersonated || lgnSrc === "nesttrader", pattern: emailRegex.source, value: currEmailvalue, onChange: (e) => {
                                                const trimmedValue = e.target.value.trim();
                                                const isValueEmpty = trimmedValue === "";
                                                const isValidEmail = emailRegex.test(trimmedValue);
                                                setCurrEmailValue(trimmedValue);
                                                setIsIconDisabled(isValueEmpty || !isValidEmail);
                                            }, placeholder: "Enter email address", required: emailCheck && emailList.length === 0, onInvalid: (e) => {
                                                if (e.currentTarget.validity.valueMissing) {
                                                    return e.currentTarget.setCustomValidity(enterMail);
                                                }
                                                if (e.currentTarget.validity.patternMismatch) {
                                                    return e.currentTarget.setCustomValidity(validMail);
                                                }
                                            }, onKeyDown: (e) => {
                                                if (e.key === "Enter" &&
                                                    !isImpersonated &&
                                                    lgnSrc !== "nesttrader") {
                                                    e.preventDefault();
                                                    EmailListUpdate();
                                                    if (inputRef && inputRef.current) {
                                                        inputRef.current.checkValidity();
                                                        inputRef.current.reportValidity();
                                                        setIsIconDisabled(currEmailvalue === "");
                                                    }
                                                }
                                            } }),
                                        React.createElement("div", null,
                                            React.createElement("i", { className: `icon ${isIconDisabled ? "icon-disabled" : ""}`, onClick: () => {
                                                    if (currEmailvalue &&
                                                        !isImpersonated &&
                                                        lgnSrc !== "nesttrader") {
                                                        EmailListUpdate();
                                                        if (inputRef && inputRef.current) {
                                                            inputRef.current.checkValidity();
                                                            inputRef.current.reportValidity();
                                                            setIsIconDisabled(currEmailvalue === "");
                                                        }
                                                    }
                                                } })))))))),
                    React.createElement("div", null,
                        React.createElement("button", { className: "btn btn-primary custom_btn", type: "submit", disabled: !submitDisabled }, "Submit")))))) : (React.createElement(React.Fragment, null,
            !!isAdditionalMsg && (React.createElement("div", { className: "bg_old-lace p-10 mb-1" },
                React.createElement("span", { className: "DMSanN_14_400 txt-orange-light" }, isAdditionalMsg))),
            React.createElement("form", { className: "customFormSection", onSubmit: (e) => handleSubmit(e), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        if (!currEmailvalue && submitDisabled) {
                            handleSubmit(e);
                        }
                    }
                } },
                React.createElement("div", { className: "downloadreport-form-block" },
                    !props.dateRequired && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "col-md-12 col-lg-12 common-download-report" },
                            React.createElement("div", { className: "date-input-section " },
                                React.createElement("div", { className: `DMSanM_14_500 ${selectedDateRange === "startDateSelected"
                                        ? "txt-midight-blue"
                                        : "txt-secondary-gray"}` },
                                    React.createElement("label", { htmlFor: "date", className: "label" }, "From Date"),
                                    React.createElement("div", { className: "input-group yearDropdown common-datepicker", onClick: () => {
                                            var _a;
                                            ((_a = props.NoCalenderInBetween) === null || _a === void 0 ? void 0 : _a.hideBetweenCal)
                                                ? props.NoCalenderInBetween.functionality()
                                                : setOpenCalendarBetween(true);
                                        } },
                                        React.createElement("input", { type: "text", className: `date-drawer-input-field user-select-none ${selectedDateRange === "startDateSelected"
                                                ? "txt-midight-blue"
                                                : "txt-secondary-gray"}`, value: moment(fromDate).format("D-MMM-YY"), readOnly: true }),
                                        React.createElement("a", { className: "input-group-append" },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }))))),
                                React.createElement("div", { className: `DMSanM_14_500 ${selectedDateRange === "endDateSelected"
                                        ? "txt-midight-blue"
                                        : "txt-secondary-gray"}

                     ` },
                                    React.createElement("label", { htmlFor: "date", className: "label" }, "To Date"),
                                    React.createElement("div", { className: "input-group yearDropdown", onClick: () => {
                                            var _a;
                                            ((_a = props.NoCalenderInBetween) === null || _a === void 0 ? void 0 : _a.hideBetweenCal)
                                                ? props.NoCalenderInBetween.functionality()
                                                : setOpenCalendarBetween(true);
                                        } },
                                        React.createElement("input", { type: "text", className: `date-drawer-input-field user-select-none${selectedDateRange === "endDateSelected"
                                                ? "txt-midight-blue"
                                                : "txt-secondary-gray"}`, value: selectedDateRange === "endDateSelected"
                                                ? "Select End Date"
                                                : moment(toDate).format("D-MMM-YY"), readOnly: true }),
                                        React.createElement("a", { className: "input-group-append" },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }))))))),
                        openCalendarBetween && (React.createElement("div", { className: "yearDropdown singleDatePicker holdingReportsDate rangeDatePickerContainer  arrows-in-yeardrop" },
                            React.createElement(DatePicker, { dateFormat: "d-MMM-yy", onChange: dateChange, startDate: fromDate, endDate: toDate, selectsRange: true, inline: true, selected: fromDate, minDate: props.minDate ? props.minDate : pnlDownloadDate, maxDate: previousDay, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), showYearDropdown: true, showMonthDropdown: true, useShortMonthInDropdown: true, 
                                // scrollableYearDropdown={true}
                                yearDropdownItemNumber: props.minDate
                                    ? previousDay.getFullYear() -
                                        props.minDate.getFullYear() +
                                        1
                                    : previousDay.getFullYear() -
                                        pnlDownloadDate.getFullYear() +
                                        1 }))))),
                    React.createElement("div", { className: "mobFormWrap mobFormWrap-content" },
                        props.dateSection && props.dateSection,
                        React.createElement("div", { className: "mailCheckbox" },
                            React.createElement("div", { className: "customFormSection_field checkboxWrap" },
                                React.createElement("label", { htmlFor: "", className: "date-label txt_blackOne1 " }, "Select Option"),
                                React.createElement("div", { className: "checkbox" },
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", name: "downloadType[]", id: "flexCheckDefault", disabled: (isImpersonated &&
                                                lgnSrc !== "nesttrader" &&
                                                PDF_or_Excel &&
                                                PDF_or_Excel === ReportType.EXCEL) ||
                                                sales_native_app, checked: isImpersonated &&
                                                PDF_or_Excel === ReportType.EXCEL
                                                ? false
                                                : downloadCheck, onChange: (e) => {
                                                setDownloadCheck(e.target.checked);
                                            }, required: !(downloadCheck || emailCheck) }),
                                        React.createElement("label", { className: `form-check-label ${downloadCheck && "txt-midnight-blue "}`, htmlFor: "flexCheckDefault" }, "Download")),
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckChecked", name: "downloadType[]", onChange: (e) => {
                                                // setshowMailInput(e.target.checked);
                                                setEmailCheck(e.target.checked);
                                            }, required: !(downloadCheck || emailCheck) }),
                                        React.createElement("label", { className: ` ${emailCheck && "txt-midnight-blue "} form-check-label `, htmlFor: "flexCheckChecked" }, "Email")))),
                            emailCheck && (React.createElement("div", { className: "customFormSection_field mailWrap" },
                                React.createElement("div", { className: "blue_bg bg_white mail" },
                                    emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                        React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                            return (React.createElement("li", { key: idx, className: "mail_label_body_item" },
                                                React.createElement("div", { className: "text-truncate" }, el),
                                                !sales_native_app && (React.createElement("span", { className: "mail_label_close", onClick: () => setEmailList((emailList) => emailList.filter((_, i) => emailList[i] !== el)) },
                                                    React.createElement("i", { className: "edel-icon-rounded-close" })))));
                                        })))),
                                    !sales_native_app && (React.createElement("div", { className: "mail-input" },
                                        React.createElement("input", { ref: inputRef, type: "email", className: "form-control", disabled: isImpersonated || lgnSrc === "nesttrader", pattern: emailRegex.source, value: currEmailvalue, onChange: (e) => {
                                                const trimmedValue = e.target.value.trim();
                                                const isValueEmpty = trimmedValue === "";
                                                const isValidEmail = emailRegex.test(trimmedValue);
                                                setCurrEmailValue(trimmedValue);
                                                setIsIconDisabled(isValueEmpty || !isValidEmail);
                                            }, placeholder: "Enter email address", required: emailCheck && emailList.length === 0, onInvalid: (e) => {
                                                if (e.currentTarget.validity.valueMissing) {
                                                    return e.currentTarget.setCustomValidity(enterMail);
                                                }
                                                if (e.currentTarget.validity.patternMismatch) {
                                                    return e.currentTarget.setCustomValidity(validMail);
                                                }
                                            }, onKeyDown: (e) => {
                                                if (e.key === "Enter" &&
                                                    !isImpersonated &&
                                                    lgnSrc !== "nesttrader") {
                                                    e.preventDefault();
                                                    EmailListUpdate();
                                                    if (inputRef && inputRef.current) {
                                                        inputRef.current.checkValidity();
                                                        inputRef.current.reportValidity();
                                                    }
                                                }
                                            } }),
                                        React.createElement("div", { className: `icon ${isIconDisabled ? "icon-disabled" : ""}` },
                                            React.createElement("i", { className: "edel-icon-add", onClick: () => {
                                                    if (currEmailvalue &&
                                                        !isImpersonated &&
                                                        lgnSrc !== "nesttrader") {
                                                        EmailListUpdate();
                                                        if (inputRef && inputRef.current) {
                                                            inputRef.current.checkValidity();
                                                            inputRef.current.reportValidity();
                                                        }
                                                    }
                                                } })))))))),
                        React.createElement("div", { className: "customFormSection_field radioField" },
                            React.createElement("label", { htmlFor: "", className: "date-label txt_blackOne1" }, "Get Report As"),
                            React.createElement("div", { className: "radio" },
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: (e) => setPDForExcel(ReportType.PDF), required: true, checked: PDF_or_Excel !== null &&
                                            PDF_or_Excel === ReportType.PDF
                                            ? true
                                            : false }),
                                    React.createElement("label", { className: `form-check-label ${PDF_or_Excel === ReportType.PDF &&
                                            "txt-midnight-blue"}`, htmlFor: "flexRadioDefault1" }, "PDF")),
                                props.hideExcel ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: (e) => {
                                            setPDForExcel(ReportType.EXCEL);
                                            isImpersonated && setDownloadCheck(false);
                                        }, checked: PDF_or_Excel !== null &&
                                            PDF_or_Excel === ReportType.EXCEL
                                            ? true
                                            : false, 
                                        // disabled={isImpersonated && lgnSrc !== "nesttrader"}
                                        required: true }),
                                    React.createElement("label", { className: `form-check-label ${PDF_or_Excel === ReportType.EXCEL &&
                                            "txt-midnight-blue"}`, htmlFor: "flexRadioDefault2" }, "Excel")))))),
                    !isClientLogin &&
                        !avoidPANProtectionMessage.includes(activeSubTabOtherReport) && (React.createElement("div", { className: "my-3" },
                        React.createElement(PANPassword, null))),
                    React.createElement("div", { className: "mgt-15" },
                        React.createElement("button", { className: "btn btn-primary custom_btn btn-bg-report", type: "submit", disabled: props.customDisableSubmit
                                ? props.customDisableSubmit(fromDate, toDate) ||
                                    !submitDisabled
                                : !submitDisabled }, "Get My Report")))))))));
};
export default CommonDownloadReport;
